export default {
  operator: "Operador",
  project: "Proyecto",
  identificationNumber: "Número de Identificación",
  selectField: "Seleccionar Campo",
  selectOperator: "Seleccionar operador",
  rule: "Regla",
  ruleSet: "Conjunto de Reglas",
  not: "No",
  selectValueSource: "Seleccionar fuente de valor",
  errorGroupQuery: "No se pudieron obtener resultados ya que hay un problema con la consulta.",
  updateQueryMessage: "Por favor actualiza las reglas de consulta del grupo.",
  emptyGroupNameMessage: "El nombre del grupo no puede estar vacío.",
};
